import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// These values are not secrets - a Firebase web config is public by design.
// Access is controlled by firestore.rules and Firebase Auth, not by hiding this.
const firebaseConfig = {
  apiKey: 'AIzaSyBSxTeNbzqeT9pyr1QmvHvrn5a8xszIRTE',
  authDomain: 'backup-dashboard-830a4.firebaseapp.com',
  projectId: 'backup-dashboard-830a4',
  storageBucket: 'backup-dashboard-830a4.firebasestorage.app',
  messagingSenderId: '1026890137294',
  appId: '1:1026890137294:web:3c78db89cda35249479a9f',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
